import React from 'react'

import { withRouter } from 'react-router-dom';

import { Text, Empty, ProfilePicture, Aligner, InfosBar } from 'components';
import { Checkbox, Container, Segment } from 'semantic-ui-react';

import { EnumBreed, EnumDiscipline } from 'enums';

import { API } from 'services';

import { Typeof } from 'utils';

import moment from 'moment';

import './style.css';

class PaneInformations extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {

    const { horse } = this.props;

    let previous = horse.active;
    let next = !previous;

    horse.active = next;

    this.forceUpdate(() => {

      API.put(`/horses/${horse.uuid}/toggle${API.queryParams({ active: next })}`)
        .then((response) => {
          next = response.data.active;
        })
        .catch(() => {
          next = previous;
        })
        .finally(() => {

          horse.active = next;
          this.forceUpdate();
        });
    });

  }

  render() {

    const { horse } = this.props;

    let age = 0;

    if(horse.birth_year) {
      age = new Date().getFullYear() - horse.birth_year;
    }

    const renderBreed = () => {

      let isCustom = horse.breed === EnumBreed.CUSTOM;
      let name = EnumBreed.name(horse.breed, horse.breed_custom);

      if (Typeof.string(name)) {
        return <Text italic={isCustom}>{name}</Text>;
      } else {
        return <Empty />;
      }
    };

    const renderDiscipline = () => {

      let isCustom = horse.discipline === EnumDiscipline.CUSTOM;
      let name = EnumDiscipline.name(horse.discipline, horse.discipline_custom);

      if (Typeof.string(name)) {
        return <Text italic={isCustom}>{name}</Text>;
      } else {
        return <Empty />;
      }
    };

    return (
      <React.Fragment>

        {/* Informations */}
        <Container>

          {/* Picture */}
          <Segment basic clearing>
            <Aligner>
              <ProfilePicture srcBase64={horse.picture} size="large" />
            </Aligner>
          </Segment>

          <Segment.Group>

            {/* Name */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Nom</span>
                <Text>{horse.name}</Text>
              </Aligner>
            </Segment>

            {/* Owner */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Propriétaire</span>

                {horse.owner ? (
                  <Text style={{"capitalize" : true}}>{horse.owner}</Text>
                ) : (
                  <Empty />
                )}
              </Aligner>
            </Segment>

            {/* Stable */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Écurie</span>

                {horse.stable ? (
                  <Text style={{"capitalize" : true}}>{horse.stable}</Text>
                ) : (
                  <Empty />
                )}
              </Aligner>
            </Segment>

          </Segment.Group>

          {/* Sire ID */}
          <Segment.Group>
            <Segment>
              <Aligner horizontal="space-between">
                <span>N° de SIRE</span>

                {horse.sire_id ? (
                  <Text style={{"mono" : true}}>{horse.sire_id}</Text>
                ) : (
                  <Empty />
                )}
              </Aligner>
            </Segment>
          </Segment.Group>

          <Segment.Group vertical>

            {/* Gender */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Sexe</span>

                {horse.gender ? (
                  <Text>{horse.gender}</Text>
                ) : (
                  <Empty />
                )}
              </Aligner>
            </Segment>

            {/* Breed */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Race</span>
                {renderBreed()}
              </Aligner>
            </Segment>

            {/* Discipline */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Discipline</span>
                {renderDiscipline()}
              </Aligner>
            </Segment>

            {/* Age */}
            <Segment>
              <Aligner horizontal="space-between">
                <span>Age</span>

                {horse.birth_year ? (
                  <Text>{age}</Text>
                ) : (
                  <Empty />
                )}

              </Aligner>
            </Segment>

          </Segment.Group>

          {/* Active */}
          <Segment raised>
            <Checkbox label="Actif" fitted toggle checked={horse.active} onChange={this.handleChange} />
          </Segment>

          <InfosBar mode="row">
            <span>Dernière mise à jour le</span>
            {horse.date_update ? (
              <span>{moment.unix(horse.date_update).format('DD/MM/YYYY [à] HH:mm:ss')}</span>
            ) : (
              <Empty />)
            }
          </InfosBar>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(PaneInformations);
